import React from 'react';
import {
  List, ListItemButton, ListItemText, Chip, Typography, Box,
} from '@mui/material';

const STATUS_LABEL = {
  open:        'Offen',
  in_progress: 'In Bearbeitung',
  answered:    'Beantwortet',
  done:        'Erledigt',
  outgoing:    'Gesendet',
  booking:     'Anmeldung',
  bounce:      'Unzustellbar',
  junk:        'SPAM',
};

const STATUS_COLOR = {
  open:        'warning',
  in_progress: 'info',
  answered:    'success',
  done:        'default',
  outgoing:    'primary',
  booking:     'secondary',
  bounce:      'error',
  junk:        'default',
};

export default function EmailList({ emails, selectedId, onSelect }) {
  return (
    <List disablePadding>
      {emails.map(email => (
        <ListItemButton
          key={email.id}
          selected={email.id === selectedId}
          onClick={() => onSelect(email.id)}
          divider
          sx={{ alignItems: 'flex-start', py: 1.5 }}
        >
          <ListItemText
            primary={
              <Box sx={{ display: 'flex', justifyContent: 'space-between', gap: 1 }}>
                <Typography variant="body2" fontWeight={600} noWrap sx={{ flexGrow: 1 }}>
                  {email.status === 'outgoing' ? '→' : email.sender_email}
                </Typography>
                <Box sx={{ display: 'flex', gap: 0.5, flexShrink: 0 }}>
                  {email.club_name && (
                    <Chip label={email.club_name} size="small" variant="outlined" />
                  )}
                  <Chip
                    label={STATUS_LABEL[email.status] ?? email.status}
                    color={STATUS_COLOR[email.status] ?? 'default'}
                    size="small"
                  />
                </Box>
              </Box>
            }
            secondary={
              <>
                <Typography variant="body2" noWrap color="text.primary">{email.subject}</Typography>
                <Typography variant="caption" color="text.secondary">
                  {email.received_at
                    ? new Date(email.received_at).toLocaleString('de-DE', { dateStyle: 'short', timeStyle: 'short' })
                    : ''}
                </Typography>
              </>
            }
          />
        </ListItemButton>
      ))}
    </List>
  );
}
